import React, { useCallback, useState, Component } from 'react';
import axios from '../modules/api';
import http from '../modules/api';
import * as StyleUtil from '../modules/utils/StyleUtil';
import * as StringUtil from '../modules/utils/StringUtil';
import {Line} from 'react-chartjs-2';
import { NavLink, Link, Prompt } from 'react-router-dom';
import $ from 'jquery';
import Slider from "react-slick";
import plus_img from '../../resources/img/plus.svg';
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import CheckBox from '../modules/common/CheckBox';

import ReactGA, { send } from 'react-ga';
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";
ReactGA.initialize('UA-78553461-8', {
    titleCase: false,
});

let window_scrollTop; // 스크롤 위치

export class AiRpEventList extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            ai_rp_event_list: [],
            checked_list: [],
            ai_rp_page_cd_list: [],
            ai_algorithm_type_cd_list: [],
            filter_page_id_list: [],
            filter_ai_alias_type_cd_list: [],
            popupData: null, // 팝업 데이터
        }
    }

    componentWillMount() {

    }

	componentDidMount() {
        this.loaAaiAlgorithmTypeCdList();
        this.loaAaiRpPageCdList ();
        this.loadAiRpEventList();
    }

    componentDidUpdate() {
    }

    componentWillUnmount(e) {

    }

    /** AI 추천 진열 목록 조회 */
    loadAiRpEventList () {
        this.setState({
            ai_rp_event_list : [],
            checked_list : [],
        }, () => {
            const body = {
                iframe_page_id_list: this.state.filter_page_id_list,
                ai_alias_type_cd_list: this.state.filter_ai_alias_type_cd_list,
            }
            const config = {
                headers: {
                    'content-type': 'application/json;'
                }
            }
            http.post("/rest/shop/aiRpEventList", body, config) 
            // 백엔드에서 filter_page_id가 적용되는 부분은 쿼리 rpMapper.selectRpEventFavoriteAlgorithmList 참고
            .then(res => {
                const list = res.data.list;
                this.setState({
                    ai_rp_event_list : list
                });
            })
            .catch(error => {
            });
        });
    }

    // cafe24 진열 등록 페이지로 이동
    onCklicBtnRegistPage(e, iframe_page_id, iframe_html_id){
        // setGaEvent("메인 진열 등록 클릭");
        this.props.history.push(
            {
                pathname: `/shop/ai/rp/eventSetting?page_id=${iframe_page_id}&html_id=${iframe_html_id}`
            }
        )
    }

    // cafe24 메인 진열 등록 페이지로 이동
    addMainList(e){
        // setGaEvent("메인 진열 등록 클릭");
        this.props.history.push(
            {
                pathname: sessionStorage.getItem("solution_type_cd") == "09001"
                ? `/shop/rp/event/product/cafe24List/16006`
                : `/shop/rp/event/product/list`,
                state: { highlightType: "ranking" }
            }
        )
    }

    onCliclFilter(name, item) {
        let filter_list = this.state[name];
        const index = filter_list.indexOf(item); // 배열에서 해당 아이템의 인덱스를 찾음
        if (index === -1) {
            // 아이템이 배열에 없으면 추가
            filter_list.push(item);
        } else {
            // 아이템이 배열에 있으면 제거
            filter_list.splice(index, 1);
        }
        this.setState({
            [name]: filter_list
        }, () => {
            this.loadAiRpEventList ();
        })
    }
    
    onClickFilterAll() {
        this.setState({
            filter_page_id_list: [],
            filter_ai_alias_type_cd_list: []
        }, () => {
            this.loadAiRpEventList ();
        })
    }

    /** AI 추천 알고리즘 목록 조회 */
    loaAaiAlgorithmTypeCdList () {
        http.get("/rest/shop/aiAlgorithmTypeCdList") 
        .then(res => {
            const list = res.data.list;
            this.setState({
                ai_algorithm_type_cd_list : list
            });
        })
        .catch(error => {
        });
    }
    
    /** AI 진열 페이지 목록 조회 */
    loaAaiRpPageCdList () {
        http.get("/rest/shop/aiRpPageCdList") 
        .then(res => {
            const list = res.data.list;
            this.setState({
                ai_rp_page_cd_list : list
            });
        })
        .catch(error => {
        });
    }

    handleMenuClick = (event, rowData) => {
        event.stopPropagation();
        const rect = event.target.getBoundingClientRect();
        const popupWidth = 90; // 예상 팝업 너비
        const popupHeight = 99; // 예상 팝업 높이
      
        let top = rect.bottom + window.scrollY;
        let left = rect.left + rect.width / 2;
      
        // 화면 너비와 높이를 기준으로 위치 조정
        if (left + popupWidth / 2 > window.innerWidth) {
          left = window.innerWidth - popupWidth / 2 - 16; // 오른쪽 여백
        } else if (left - popupWidth / 2 < 0) {
          left = popupWidth / 2 + 16; // 왼쪽 여백
        }
      
        if (top + popupHeight > window.innerHeight + window.scrollY) {
          top = rect.top + window.scrollY - popupHeight; // 위로 배치
        }
      
        if (
          this.state.popupData &&
          this.state.popupData.iframe_page_id_html_id === rowData.iframe_page_id_html_id
        ) {
          // 같은 버튼 클릭 시 팝업 닫기
          this.setState({ popupData: null });
        } else {
          // 새로운 팝업 열기
          this.setState({
            popupData: {
              ...rowData,
              position: { top, left },
            },
          });
        }
    }

    closePopup = () => {
        this.setState({ popupData: null }); // 팝업 닫기
    };
    onModify = () => {
        this.setState({ popupData: null }, () => {
            alert("수정요청")
        }); // 팝업 닫기
    };
    onDelete = () => {
        this.setState({ popupData: null }, () => {
            alert("삭제요청")
        }); // 팝업 닫기
    };

    render() {
        const { popupData } = this.state;
        return (
            <>
                <div id='common-page-wrapper' className="style_guide_v2">
                    <div id="list_wrap" className="list_wrap_background" style={{overflowY:"auto"}}>
                        <div className="algorithm_list_wrap">
                            <div className="titleArea">
                                <div className='title'>나의 AI 추천</div>
                                <div className='content'>인공지능 자동추천을 위해 설치된 나의 AI추천목록을  관리할 수 있습니다</div>
                            </div>
                            <div className='flexBox algorithm_option_area' style={{justifyContent: "space-between", rowGap:"14px"}}>
                                <div className="algorithm_filter_area ai_rp_filter_area" style={{flexWrap: "wrap", gap:"14px"}}>
                                    <div className={(this.state.filter_page_id_list.length == 0 && this.state.filter_ai_alias_type_cd_list.length == 0) 
                                            || (this.state.filter_page_id_list.length == this.state.ai_rp_page_cd_list.length && this.state.filter_ai_alias_type_cd_list.length == this.state.ai_algorithm_type_cd_list.length)
                                            ? "active" : ""}
                                        onClick={() => {
                                            this.onClickFilterAll();
                                        }
                                    }
                                    style={{width:"151px", borderRadius:"50px", marginLeft:"0px"}}
                                    >전체</div>
                                    {
                                        this.state.ai_rp_page_cd_list.map((item, index) => {
                                            return ( 
                                                <div className={this.state.filter_page_id_list.indexOf(item.code_name) >= 0 ? "active" : ""}
                                                onClick={() => {
                                                    this.onCliclFilter("filter_page_id_list",item.code_name);
                                                    }
                                                }
                                                style={{width:"151px", borderRadius:"50px", marginLeft:"0px"}}
                                                >{item.val1}</div>
                                            )
                                        })
                                    }
                                    {
                                        this.state.ai_algorithm_type_cd_list.map((item, index) => {
                                            return (
                                                <div className={this.state.filter_ai_alias_type_cd_list.indexOf(item.code_cd) >= 0 ? "active" : ""}
                                                onClick={() => {
                                                    this.onCliclFilter("filter_ai_alias_type_cd_list",item.code_cd);
                                                    }
                                                }
                                                style={{width:"151px", borderRadius:"50px", marginLeft:"0px"}}
                                                >{"AI로보MD "+item.code_name}</div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="algorithm_table_area aiRpEvent_table_area">
                                <table>
                                    <thead>
                                        <tr>
                                            <td className="list_td">추천 종류</td>
                                            <td className="list_td">추천 제목</td>
                                            <td className="list_td">추천 위치</td>
                                            <td className="list_td">추천 변경일</td>
                                            <td className="list_td">추천 상품수</td>
                                            <td className="list_td">추천 등록일</td>
                                            {/* <td className="list_td"></td> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { this.state.ai_rp_event_list != null && this.state.ai_rp_event_list.length > 0
                                        ?   <>
                                            {
                                                this.state.ai_rp_event_list.map((obj, idx) => (
                                                    <tr key={obj.iframe_page_id+'_'+obj.iframe_html_id} onClick={e => {this.onCklicBtnRegistPage(e, obj.iframe_page_id, obj.iframe_html_id);}}>
                                                        <td>
                                                            <div>
                                                                <div style={{
                                                                    width:"57px", 
                                                                    height:"57px",
                                                                    minWidth: "57px",
                                                                    marginRight:"16px", 
                                                                    backgroundSize: "contain",
                                                                    backgroundPosition: "center",
                                                                    backgroundRepeat: "no-repeat",
                                                                    backgroundImage: ("url(" + obj.ai_algorithm_type_sumnail_img_url + ")"),
                                                                }}>
                                                                </div>
                                                                <div>
                                                                {
                                                                    obj.ai_alias_type_title.replaceAll("{{ai_alias_type_name}}", obj.ai_alias_type_name)
                                                                    +(obj.ai_alias_type_title && obj.ai_algorithm_name && " | ")
                                                                    +obj.ai_algorithm_name
                                                                }
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {obj.display_name}
                                                        </td>
                                                        <td>
                                                            {obj.iframe_page_name}
                                                        </td>
                                                        <td>
                                                            {obj.ai_last_processed_date_format}
                                                        </td>
                                                        <td>
                                                            {StringUtil.numberComma(obj.product_cnt)}
                                                        </td>
                                                        <td>
                                                            {obj.reg_date_format}
                                                        </td>
                                                        {/* <td class="recommendation-row" onClick={(event) => {event.stopPropagation();}}>
                                                            <svg className="menu-btn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(event) => this.handleMenuClick(event, obj)}>
                                                                <path d="M12 7.125C11.7775 7.125 11.56 7.05902 11.375 6.9354C11.19 6.81179 11.0458 6.63609 10.9606 6.43052C10.8755 6.22495 10.8532 5.99875 10.8966 5.78052C10.94 5.5623 11.0472 5.36184 11.2045 5.20451C11.3618 5.04717 11.5623 4.94003 11.7805 4.89662C11.9988 4.85321 12.225 4.87549 12.4305 4.96064C12.6361 5.04578 12.8118 5.18998 12.9354 5.37498C13.059 5.55999 13.125 5.7775 13.125 6C13.125 6.29837 13.0065 6.58452 12.7955 6.7955C12.5845 7.00647 12.2984 7.125 12 7.125ZM13.125 18C13.125 17.7775 13.059 17.56 12.9354 17.375C12.8118 17.19 12.6361 17.0458 12.4305 16.9606C12.225 16.8755 11.9988 16.8532 11.7805 16.8966C11.5623 16.94 11.3618 17.0472 11.2045 17.2045C11.0472 17.3618 10.94 17.5623 10.8966 17.7805C10.8532 17.9988 10.8755 18.225 10.9606 18.4305C11.0458 18.6361 11.19 18.8118 11.375 18.9354C11.56 19.059 11.7775 19.125 12 19.125C12.2984 19.125 12.5845 19.0065 12.7955 18.7955C13.0065 18.5845 13.125 18.2984 13.125 18ZM13.125 12C13.125 11.7775 13.059 11.56 12.9354 11.375C12.8118 11.19 12.6361 11.0458 12.4305 10.9606C12.225 10.8755 11.9988 10.8532 11.7805 10.8966C11.5623 10.94 11.3618 11.0472 11.2045 11.2045C11.0472 11.3618 10.94 11.5623 10.8966 11.7805C10.8532 11.9988 10.8755 12.225 10.9606 12.4305C11.0458 12.6361 11.19 12.8118 11.375 12.9354C11.56 13.059 11.7775 13.125 12 13.125C12.2984 13.125 12.5845 13.0065 12.7955 12.7955C13.0065 12.5845 13.125 12.2984 13.125 12Z" fill="#828282"/>
                                                            </svg>
                                                        </td> */}
                                                    </tr>
                                                ))
                                            }
                                            </>
                                        :
                                            ""
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {/* 카드 영역: 모바일(800px 이하)에서만 보임 */}
                            { this.state.ai_rp_event_list != null && this.state.ai_rp_event_list.length > 0
                            ?   <>
                                {
                                    this.state.ai_rp_event_list.map((obj, idx) => (
                                        <div className="algorithm_card ai_rp_event_card">
                                            {/* <div className="algorithm_card-header">
                                                <CheckBox
                                                    id={"list_algorithm_card_checkbox_" + (Number(idx))}
                                                    value={idx}
                                                    checked={this.state.checked_list.find(rp => rp.seq == obj.seq ) != null}
                                                    onChangeCheck={this.checkOneRpAlgorithmListOnChange.bind(this)}
                                                />
                                                <span className="algorithm_card-title">{obj.algorithm_name}</span>
                                            </div> */}
                                            <div className="algorithm_card-meta">
                                                <span>
                                                {
                                                    obj.iframe_page_id != "robomd_cafe24_category_page" 
                                                    ? obj.iframe_page_simple_name 
                                                    : obj.iframe_page_simple_name
                                                        +   (obj.cafe24_category_display_group == "1" 
                                                            ? " (일반)"
                                                            : obj.cafe24_category_display_group == "2" 
                                                                ? " (추천)"
                                                                : obj.cafe24_category_display_group == "3" 
                                                                    ? " (신상)" 
                                                                    : "")
                                                }
                                                </span>
                                                <span>{obj.reg_date_format}</span>
                                            </div>
                                        </div>
                                    ))
                                }
                                </>
                            :
                                ""
                            }
                        </div>
                    </div>
                </div>
                {popupData && (
                    <Popup
                        data={popupData}
                        position={popupData.position}
                        onClose={this.closePopup}
                        onModify={this.onModify}
                        onDelete={this.onDelete}
                    />
                )}
                {
					(this.state.confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({confirm_dialog_show_state: false});
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
					: ''
				}
                {
					(this.state.basic_dialog_show_state === true)
					? <BasicDialogV2
						content={this.state.basic_dialog_content}
						button_list={this.state.basic_dialog_button_list}
					/>
					: ''
				}
                {
                    (this.state.delete_dialog_show_state === true)
                        ? <ConfirmDialogV2
                            content={this.state.delete_dialog_content}
                            button_list={this.state.delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_period_title_content_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            title={ this.state.is_finish == 0 ? this.state.remain_date+"일 뒤 "+this.state.payment_cls_text+"이 종료됩니다. <br/> 기간을 연장하시겠습니까?" : this.state.payment_cls_text+"이 종료되었습니다. <br/> 기간을 연장하시겠습니까?" }
                            content={this.state.payment_cls_text + " 기간<br/>" +  this.state.start_date_format + " ~ " + this.state.end_date_format}
                            button_list={this.state.title_content_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_period_title_content_dialog_show_state: false});
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_delete_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            content={this.state.notice_delete_dialog_content}
                            button_list={this.state.notice_delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {/* {this.state.tutorial_dialog_state &&
					<TitleContentDialogV2
						title={"로보MD 진열 사용하러 가볼까요?"}
						content={"다양한 자동 진열기능을 사용해 보시고<br/>자동 진열되는 상품결과를 미리보고 체험하세요."}
						button_list={[
                            {
                                title: "진열기능보기",
                                type: "1",
                                event_method: () => {
                                    this.addMainList();
                                    //팝업 닫기
                                    this.setState({
                                        tutorial_dialog_state: false,
                                        notice_period_title_content_dialog_show_state : false,
                                    });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            },
                            {
                                title: "닫기",
                                type: "0",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({ tutorial_dialog_state: false });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            }
                        ]}
                        popup_close={() => {
                            this.setState({ tutorial_dialog_state: false });
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
				} */}
            </>
        )
    };
}

class Popup extends Component {
    render() {
      const { data, position, onClose, onModify, onDelete } = this.props;
  
      return (
        <div
          className="menu-popup"
          style={{
            position: "absolute",
            top: position.top,
            left: position.left,
            transform: "translateX(-50%)",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            padding: "8px 0",
          }}
        >
          <div className="menu-item" onClick={onModify}>
            수정요청 
            {/* {data.iframe_page_id_html_id} */}
          </div>
          <div className="menu-item" onClick={onDelete}>
            삭제요청
          </div>
        </div>
      );
    }
  }